export default "__VITE_ASSET__DDTzkO6B__"